import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectTags, orderedTags } from 'store/Tags/selectors';
import TagsModal from 'Common/Components/TagsModal';
import {
  selectExploreGroupSelectedHostObjects,
  selectExploreGroupSelectedHostsTags
} from 'store/GroupVulns/selectors';
import {
  addExploreGroupHostTag,
  removeExploreGroupHostTag,
  setExploreGroupHostNewTags
} from 'store/GroupVulns/actions';

const ExploreGroupHostsTagsModal = () => {
  const dispatch = useDispatch();
  const wsTags = useSelector(selectTags);
  const selectedHosts = useSelector(selectExploreGroupSelectedHostObjects);
  const hostsTags = useSelector(selectExploreGroupSelectedHostsTags);
  const tags = useSelector((state) => orderedTags(state, hostsTags, selectedHosts));

  const onClickTag = (tag) => {
    if (tag.partialSelected) {
      dispatch(addExploreGroupHostTag(tag.name));
    } else {
      if (tag.addedToVuln) dispatch(removeExploreGroupHostTag(tag.name));
      else dispatch(addExploreGroupHostTag(tag.name));
    }
  };

  const addTags = (newTags) => {
    dispatch(setExploreGroupHostNewTags(newTags));
  };

  return (
    <TagsModal tags={ tags } onClickTag={ onClickTag } addTags={ addTags } allTags={ wsTags } entity="exploreGroupHosts" />
  );
};

export default ExploreGroupHostsTagsModal;
